/* eslint-disable import/prefer-default-export */
export function cnpjMask(value) {
  value = value.replace(/\D/g, '');
  if (value.length <= 11) {
    value = value.replace(/^(\d{3})(\d)/, '$1.$2');
    value = value.replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3');
    value = value.replace(/\.(\d{3})(\d)/, '.$1-$2');
    value = value.replace(/(-\d{2})\d+?$/, '$1');
  } else {
    value = value.replace(/^(\d{2})(\d)/, '$1.$2');
    value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
    value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
    value = value.replace(/(\d{4})(\d)/, '$1-$2');
    value = value.replace(/(-\d{2})\d+?$/, '$1');
  }
  return value;
}

export function telefoneMask(value) {
  value = value.replace(/\D/g, '');
  value = value.replace(/^(\d{2})(\d)/g, '($1) $2');
  value = value.replace(/(\d)(\d{4})$/, '$1-$2');
  return value;
}

export function cepMask(value) {
  value = value.replace(/\D/g, '');
  value = value.replace(/^(\d{5})(\d)/g, '$1-$2');
  return value;
}

export function removeCaracteres(value) {
  return value.replace(/\D/g, '');
}

export function moneyToMask(number) {
  let newNumber = number;

  newNumber = newNumber.replace(/\D/g, '');
  newNumber = newNumber.replace(/(\d)(\d{2})$/, '$1,$2');
  newNumber = newNumber.replace(/(?=(\d{3})+(\D))\B/g, '.');
  return newNumber;
}
export function maskToMoney(number) {
  let newNumber = number;
  if (typeof newNumber !== 'string') {
    newNumber = newNumber.toString();
  }
  newNumber = newNumber.replace('.', '');
  newNumber = newNumber.replace(',', '.');
  return parseFloat(newNumber);
}
export function toCurrency(number, showRs) {
  if (!showRs) {
    return number.toLocaleString('pt-br', { minimumFractionDigits: 2 });
  }
  return number.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
}
